import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { antdNotification } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import Button from '@hellodarwin/core/lib/components/common/button';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Download from '@hellodarwin/icons/dist/icons/Download';
import Tooltip from 'antd/es/tooltip';
import { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useTheme } from 'styled-components';
import { PdfViewerDocument, PdfViewerPages, PdfViewerRoot, PdfViewerToolbar, } from './styles';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const PdfViewer = ({ pdfFile, onDownload, onError, fitContainer = false, }) => {
    const { t } = useTranslations();
    const theme = useTheme();
    const [numPages, setNumPages] = useState();
    const [error, setError] = useState(null);
    const containerRef = useRef(null);
    const containerPadding = theme.spacing.md;
    const [pageWidth, setPageWidth] = useState();
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        const updateWidth = (width) => {
            setPageWidth(Math.max(0, width - containerPadding - containerPadding));
        };
        updateWidth(container.clientWidth);
        const resizeObserver = new ResizeObserver(() => {
            updateWidth(container.clientWidth);
        });
        resizeObserver.observe(container);
        return () => resizeObserver.disconnect();
    }, [containerPadding]);
    const onDocumentLoadSuccess = ({ numPages: nextNumPages, }) => {
        setNumPages(nextNumPages);
        setError(null);
    };
    const onDocumentLoadError = (error) => {
        console.error('PDF loading error:', error);
        antdNotification.error({
            message: t('errors|pdf_error'),
            description: error.name,
            placement: 'bottomLeft',
        });
        setError(`Failed to load PDF: ${error.message}`);
        onError === null || onError === void 0 ? void 0 : onError(error);
    };
    if (error) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(PdfViewerRoot, { "$fitContainer": fitContainer, children: [_jsx(PdfViewerToolbar, { children: _jsx(Tooltip, { title: t('gamePlanPdf|download'), children: _jsx(Button, { defaultStyle: theme.colors.grey_1, headingIcon: _jsx(Download, { size: theme.spacing.lg }), size: "square", onClick: onDownload }) }) }), _jsx(PdfViewerDocument, { ref: containerRef, children: _jsx(Document, { file: pdfFile, onLoadSuccess: onDocumentLoadSuccess, onLoadError: onDocumentLoadError, children: _jsx(PdfViewerPages, { children: Array.from(new Array(numPages), (_el, index) => (_jsx(Page, { pageNumber: index + 1, width: pageWidth }, `page_${index + 1}`))) }) }) })] }));
};
export default PdfViewer;
